import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-sl1-filter',
  templateUrl: './sl1-filter.component.html',
  styleUrls: ['./sl1-filter.component.scss']
})
export class Sl1FilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterDesignService: any[];
  optionSelected: any;

  @Input() designServicesData: any;
  @Input() designServicesSelected: DesignServicesModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('designServicesData' in changes) {
      this.listFilterDesignService = this.designServicesData ? this.designServicesData : [];
      this.optionSelected = null;
    }
    if (this.designServicesSelected) {
      this.optionSelected = this.designServicesSelected;
    }
  }

  ngOnDestroy(): void {
  }
}
